module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADbSURBVDiN7dI/D8FAHMbx5/wZbEa2DhJJraLGJl6CN+CleCleBZvNaGUVQiwES2P6Wq7R0F7VYvFMd7n7fe5+7UmOAB7PeK69JddikfyhX0JAOa8IqDghwJe0BgIH0pa0Avquk5b28V2A7uuDBFrA3s63QDXzNOBgN56BYQIaADs7vgK9vP6TWJSATgkks/VXzAeOvOfq/DYfYsWRFOyWhxhgbMcTY8wmBetIqhtjFilrnqRRPIkTfnHjMC6uSIok1SQFQFErbjcSMEv5O0UzFdAE5sD9C+BuaxsPnR6bXVUR9coAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-preview/component/images/image-download.png
// module id = OCJn
// module chunks = 4